import { NgModule } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { CustomThemeModule } from '../custom-theme/custom-theme.module'
import { Gridster, GridsterItem } from 'angular-gridster2';
import { WidgetDirective } from './widget.directive';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    CustomThemeModule,
    Gridster,
    GridsterItem,
    WidgetDirective,
    NgOptimizedImage
  ],
  exports: [CommonModule, TranslatePipe, TranslateDirective, CustomThemeModule, Gridster, GridsterItem, WidgetDirective, NgOptimizedImage]
})
export class SharedModule { }
